// extracted by mini-css-extract-plugin
export default {"mainMenu":"SettingsWindow_mainMenu__7NkOl","breadcrumb":"SettingsWindow_breadcrumb__XC9WB"};